'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$State) {
  _inherits(_class, _Phaser$State);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {}
  }, {
    key: 'preload',
    value: function preload() {
      this.loaderBg = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'loaderBg');
      this.loaderBar = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'loaderBar');
      (0, _utils.centerGameObjects)([this.loaderBg, this.loaderBar]);

      this.load.setPreloadSprite(this.loaderBar);

      //
      // load your assets
      //
      this.load.image('background', 'assets/images/background.png');

      this.load.image('lentilsoy', 'assets/images/lentilsoy.png');
      this.load.image('fish_bowl', 'assets/images/fish_bowl.png');
      this.load.image('telephone', 'assets/images/telephone.png');

      this.load.image('white_square', 'assets/images/white_square.png');
      this.load.image('red_button', 'assets/images/red_button.jpg');
      this.load.image('screen', 'assets/images/screen.png');
      this.load.image('terminal_icon', 'assets/images/terminal_icon.png');
      this.load.image('signal_icon', 'assets/images/signal_icon.png');
      this.load.image('signal_dial', 'assets/images/dial.png');

      this.load.spritesheet('fish', 'assets/images/fish.png', 200, 200);
      this.load.spritesheet('pulse', 'assets/images/pulse.png', 181, 149);

      this.load.audio('beep', 'assets/sfx/PhoneDial_SingleButtonPush.ogg');
      this.load.audio('bad_ending', 'assets/sfx/Bad_Ending.ogg');
      this.load.audio('corrupted_stream', 'assets/sfx/GarbledMessage.ogg');
      this.load.audio('right_password', 'assets/sfx/RightPassword.ogg');
      this.load.audio('signal_fixed', 'assets/sfx/MovingDishintoPlace.ogg');
      this.load.audio('wrong_password', 'assets/sfx/WrongPassword.ogg');
      this.load.audio('at_last', 'assets/sfx/at_last.ogg');
      this.load.audio('plastic_chips', 'assets/sfx/plastic_chips.ogg');

      this.load.audio('music', 'assets/music/Music.ogg');

      this.load.json('story', 'assets/story.json');
    }
  }, {
    key: 'create',
    value: function create() {
      this.state.start('Game');
    }
  }]);

  return _class;
}(_phaser2.default.State);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/states/Splash.js
// module id = 339
// module chunks = 0